<div *ngIf="isShowBoardingCheckList && boardingCheckList != null" style="position: relative">
  <div *ngIf="!boardingCheckList.isHide" class="ui-g">
    <div class="ui-g-12">
      <h1>Registration Checklist</h1>
    </div>
    <div
      class="ui-g-12"
      *ngIf="
        boardingCheckList.organisationTypeId == 2 ||
        boardingCheckList.organisationTypeId == 3 ||
        boardingCheckList.organisationTypeId == 4
      "
    >
      To finish registering your organisation as a
      <span *ngIf="boardingCheckList.organisationTypeId == 2">customer</span>
      <span *ngIf="boardingCheckList.organisationTypeId == 3">supplier</span>
      <span *ngIf="boardingCheckList.organisationTypeId == 4">customer and a supplier</span> you
      will need to complete the following actions:
    </div>
    <div
      class="ui-g-6 ui-sm-12"
      *ngIf="customerBoardingButtons && customerBoardingButtons.length > 0"
      style="min-width: 500px"
    >
      <!--<div class="ui-g-12">
                <h2 *ngIf="boardingCheckList.organisationSubTypeId == null || (boardingCheckList.organisationSubTypeId < 4 || boardingCheckList.organisationSubTypeId > 6)">Customer</h2>
                <h2 *ngIf="boardingCheckList.organisationSubTypeId == 4">Customer – Individual</h2>
                <h2 *ngIf="boardingCheckList.organisationSubTypeId == 5">Customer – Generic</h2>
                <h2 *ngIf="boardingCheckList.organisationSubTypeId == 6">Customer – Bespoke</h2>
            </div>-->
      <!--<div class="ui-g-12" *ngIf="AnyIsOptional(customerBoardingButtons, false)">-->
      <!--<h2>Mandatory:</h2>-->
      <!--</div>-->
      <div *ngFor="let customerBoardingButton of customerBoardingButtons" class="ui-g-12">
        <button
          *ngIf="customerBoardingButton.isValid && !customerBoardingButton.isOptional"
          pButton
          label="{{ customerBoardingButton.name }}"
          (click)="GoTo(customerBoardingButton)"
          class="ui-g-12"
          icon="fa ui-icon-check-box"
          [class.green-btn]="customerBoardingButton.isMarkAsUsed"
        ></button>
        <button
          *ngIf="!customerBoardingButton.isValid && !customerBoardingButton.isOptional"
          class="ui-g-12"
          pButton
          label="{{ customerBoardingButton.name }}"
          (click)="GoTo(customerBoardingButton)"
          icon="fa ui-icon-check-box-outline-blank"
          [class.green-btn]="customerBoardingButton.isMarkAsUsed"
        ></button>
      </div>
      <!--<div class="ui-g-12" *ngIf="AnyIsOptional(customerBoardingButtons, true)">
                <h2>Optional:</h2>
            </div>
            <div *ngFor="let customerBoardingButton of customerBoardingButtons" class="ui-g-12">
                <button *ngIf="customerBoardingButton.isOptional"
                        pButton label="{{customerBoardingButton.name}}" style="width:350px;"
                        (click)="GoTo(customerBoardingButton)"
                        [class.green-btn]="customerBoardingButton.isMarkAsUsed"></button>
            </div>-->
    </div>
    <div
      class="ui-g-6 ui-sm-12"
      *ngIf="supplierBoardingButtons && supplierBoardingButtons.length > 0"
    >
      <!-- <div class="ui-g-12">
                <h2 *ngIf="boardingCheckList.organisationSubTypeId == null || (boardingCheckList.organisationSubTypeId < 1 || boardingCheckList.organisationSubTypeId > 3)">Supplier</h2>
                <h2 *ngIf="boardingCheckList.organisationSubTypeId == 1">Supplier – Individual</h2>
                <h2 *ngIf="boardingCheckList.organisationSubTypeId == 2">Supplier – Generic</h2>
                <h2 *ngIf="boardingCheckList.organisationSubTypeId == 3">Supplier – Bespoke</h2>
            </div>-->
      <!--<div class="ui-g-12" *ngIf="AnyIsOptional(supplierBoardingButtons, false)">-->
      <!--<h2>Mandatory:</h2>-->
      <!--</div>-->
      <div *ngFor="let supplierBoardingButton of supplierBoardingButtons" class="ui-g-12">
        <button
          *ngIf="supplierBoardingButton.isValid && !supplierBoardingButton.isOptional"
          pButton
          label="{{ supplierBoardingButton.name }}"
          (click)="GoTo(supplierBoardingButton)"
          icon="fa ui-icon-check-box"
          class="ui-g-12"
          [class.green-btn]="supplierBoardingButton.isMarkAsUsed"
        ></button>
        <button
          *ngIf="!supplierBoardingButton.isValid && !supplierBoardingButton.isOptional"
          class="ui-g-12"
          pButton
          label="{{ supplierBoardingButton.name }}"
          (click)="GoTo(supplierBoardingButton)"
          icon="fa ui-icon-check-box-outline-blank"
          [class.green-btn]="supplierBoardingButton.isMarkAsUsed"
        ></button>
      </div>
      <!--<div class="ui-g-12" *ngIf="AnyIsOptional(supplierBoardingButtons, true)">
                <h2>Optional:</h2>
            </div>
            <div *ngFor="let supplierBoardingButton of supplierBoardingButtons" class="ui-g-12">
                <button *ngIf="supplierBoardingButton.isOptional"
                        pButton label="{{supplierBoardingButton.name}}" style="width:350px;"
                        (click)="GoTo(supplierBoardingButton)"
                        [class.green-btn]="supplierBoardingButton.isMarkAsUsed"></button>
            </div>-->
    </div>
    <div style="margin-top: 20px" class="ui-g-12">
      <button
        pButton
        label="Get Started"
        icon="fa ui-icon-check"
        [disabled]="!isAllValid()"
        (click)="HideThisScreen()"
        class="green-btn btn-to-right"
      ></button>
    </div>
  </div>
  <div
    style="
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background: gray;
      opacity: 0.3;
    "
    *ngIf="isBusy"
  >
    <img
      src="assets/images/loader.gif"
      style="margin-left: 45%; margin-top: 20%"
      width="50"
      height="50"
      alt="load"
    />
  </div>
</div>
